export default __webpack_public_path__ + "static/media/yellow.3dd6182f.svg";